<template>
    <div v-if="noticia">
        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container container-sports-content">
            <div class="row">
                <div class="col-12">
                    <h1 class="sposrts-content--title"><strong>{{noticia.title}}</strong></h1>
                    <p class="sposrts-content--subtitle">{{noticia.subtitle}}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <p class="content-author">
                        <strong>
                            {{noticia.signature || noticia.source}}
                        </strong>
                    </p>
                    <p class="content-date">
                        {{utils.date(noticia.meta.first_published_at)}} 
                        <template v-if="noticia.last_published_at">
                            <!-- Atualizada em {{utils.date(noticia.last_published_at)}} -->
                        </template>
                    </p>
                    <Share :title="title" />
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="content-featured-image" v-if="noticia.image">
                        <p class="content-featured-image--credit">{{noticia.image.credits}}</p>
                        <figure>
                            <img :src="utils.image(noticia.image, 1120, 650)" />
                            <figcaption v-if="noticia.image && noticia.image.caption">
                                {{noticia.image.caption}}
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-12 col-lg-3 col-xl-3 esportes-banner-01">
                    <div id='div-gpt-ad-1603502104885-0'></div>
                </div>
            </div>

            <template v-for="(item, key) in noticia.content">
                <Paragraph v-if="item.type=='paragraph'" :key="key" :value="item.value" />
                <Carousel v-else-if="item.type=='gallery'" :key="key" :value="item.value" />
                <Quote v-else-if="item.type=='quote'" :key="key" :value="item.value" />
                <Photo v-else-if="item.type=='image'" :key="key" :value="item.value" />
                <Video v-else-if="item.type=='video'" :key="key" :value="item.value" />
                <Audio v-else-if="item.type=='audio'" :key="key" :value="item.value" />
                <Heading v-else-if="item.type=='heading'" :key="key" :value="item.value" />
                <Embed v-else-if="item.type=='embed'" :key="key" :value="item.value" />
                <Poll v-else-if="item.type=='poll'" :key="key" :value="item.value" />
                <Carousel v-else-if="item.type=='collection'" :key="key" :value="item.value" />
            </template>

            
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-7 offset-xl-2">
                    <ul class="content-tags">
                        <li v-for="(tag,key) in noticia.tags" :key="key">
                            <a href="#" @click.prevent="$root.$emit('gazetaweb:search',tag)">{{tag}}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="OUTBRAIN" :data-src="location" data-widget-id="SF_1" data-ob-template="gazetadealagoas"></div>

            <!-- VEJA TAMBEM -->
            <div class="row">
                <div class="col-12">
                    <div class="content-seetoo">
                        <h2>Veja também</h2>
                    </div>
                </div>

                <template v-for="(related,key) in noticia.related_news">
                    <div :class="{'col-12 col-md-4 col-lg-3':true,'offset-lg-1':key % 3 === 0}"  :key="key">
                        <router-link class="noticies" :to="related.url" v-if="related">
                            <figure >
                                <img v-if="related.image" :src="utils.image(related.image, width=256, height=136)" alt="">
                                <img v-else src="@/assets/images/search-placeholder.jpg" />
                            </figure>
                            <p class="noticies__label">{{related.editorial.title}}</p>
                            <p class="noticies__title">{{related.title}}</p>
                        </router-link>
                    </div>
                </template>
            </div>

            <div class="row facebook-coments">
                <div class="col-12">
                    <h2>Comentários</h2>
                </div>
                <div class="col-12" style="text-align:center">
                    <div class="fb-comments" 
                        :data-href="permalink" 
                        data-width="" 
                        data-numposts="5"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'

import Carousel from '@/components/blocks/Carousel'
import Heading from '@/components/blocks/Heading'
import Paragraph from '@/components/blocks/Paragraph'
import Quote from '@/components/blocks/Quote'
import Photo from '@/components/blocks/Photo'
import Video from '@/components/blocks/Video'
import Audio from '@/components/blocks/Audio'
import Embed from '@/components/blocks/Embed'
import Poll from '@/components/blocks/Poll'

import Share from '@/components/Share'

import slugify from 'slugify'

export default {
    name: 'Noticia',
    props:['noticia', 'title'],
    components: {
        Paragraph, 
        Carousel, 
        Quote, 
        Photo, 
        Video, 
        Audio,
        Share,
        Heading,
        Embed,
        Poll
    },
    data: function() {
        return {
            utils: utils,
            related: [],
            permalink: null,
            location: null,
        }
    },
    methods: {
        sticky_banner() {
            var element = document.querySelector('.esportes-banner-01');
            var elementOffsetTop = element.offsetTop;
            var currentScroll = window.scrollY

            window.addEventListener('scroll', function () {
                currentScroll = window.scrollY

                if (currentScroll >= elementOffsetTop && window.innerWidth >= 1024) {
                    element.classList.add('fixed');
                } else {
                    element.classList.remove('fixed');
                }
            });
        }
    },
    created(){
        
    },
    beforeRouteLeave (to, from, next) {
        const outbrain = document.getElementById('outbrain-script')
        outbrain.parentNode.removeChild(outbrain);
        next()
    },
    mounted(){
        if (this.noticia) {
            // this.related = this.noticia.related.concat(this.noticia.related_extra)
            this.permalink = `${window.location.origin}/permalink/${this.noticia.id}`
            this.location = window.location.href

            let externalScript = document.createElement('script')
            externalScript.setAttribute('id', 'outbrain-script')
            externalScript.setAttribute('async', 'async')
            externalScript.setAttribute('src', 'https://widgets.outbrain.com/outbrain.js')
            document.head.appendChild(externalScript)
            window._ppads.checksBeforeLoad()
        }
        window.FB.XFBML.parse()

        var googletag = window.googletag
        var slug = slugify(this.noticia.editorial.title,{lower:true})
        googletag.cmd.push(function() {
            googletag.destroySlots()

            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.defineSlot('/1513505/v1_gweb_arroba_lateral', [300, 250], 'div-gpt-ad-1603502104885-0').addService(googletag.pubads());
            
            googletag.pubads().enableSingleRequest()
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
            googletag.pubads().setTargeting('categoria', [slug]).setTargeting('tipo_conteudo', ['noticias']);
            googletag.display('div-gpt-ad-1603501550614-0')
            googletag.display('div-gpt-ad-1603502104885-0')
        })

        this.sticky_banner()
    }
}
</script>